import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { FiLogOut } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { logoutApi } from "../DAL";
import { ROUTES_CONSTANTS } from "../constants";
import { ProfileImage } from "../assets";
import { useAuth } from "../context";

const ProfileMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { clearAuth } = useAuth();
  const menuRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const { mutate: logout, isPending } = useMutation({
    mutationFn: logoutApi,
    onSuccess: () => {
      clearAuth();
      navigate(ROUTES_CONSTANTS.LOGIN);
    },
  });

  return (
    <div className="relative" ref={menuRef}>
      <div
        className="w-10 h-10 border border-[#c8c8c8] flex items-center justify-center rounded-sm cursor-pointer"
        onClick={() => setMenuOpen((prev) => !prev)}
      >
        <img src={ProfileImage} alt={t("companyManagement.profileImageAlt")} />
      </div>
      {menuOpen && (
        <div className="absolute right-0 mt-2 w-40 bg-white border border-[#E3E3E3] rounded-lg shadow-lg z-50">
          <button
            disabled={isPending}
            onClick={() => logout()}
            className="flex items-center gap-2 w-full px-4 py-3 text-sm text-red-500 hover:bg-red-50 rounded-lg cursor-pointer disabled:opacity-50"
          >
            <FiLogOut className="w-4 h-4" />
            {isPending ? t("common.loggingOut") : t("common.logout")}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileMenu;
